<h2 mat-dialog-title class="title">In Progress</h2>
<hr>
<div mat-dialog-content>
    <p class="content" >Sorry for the inconvenience caused!!</p>
</div>
<hr>
<mat-dialog-actions align='center'>
    <button mat-raised-button color="primary" mat-dialog-close cdkFocusInitial>Ok</button>
</mat-dialog-actions>